module.exports = __webpack_public_path__ + "img/coffee_bean.b1924c1e.png";